import axios from "axios";

const API_GO = process.env.REACT_APP_API_GO;

export const grantSqlAccess = async (clientIp) => {
	const { data } = await axios.post(
		`${API_GO}/app/infrastructure/sql-access`,
		{ client_ip: clientIp },
		{
			headers: {
				"X-Client-Public-IP": clientIp,
			},
		},
	);
	return data;
};
